import React, { useEffect, useState } from 'react';

// core components
import WhiteNavbar from "components/Navbars/WhiteNavbar.js";
import db from '../db'
import classNames from "classnames";
import { makeStyles } from '@material-ui/core/styles';
import Question from "./Question";
import { Helmet } from "react-helmet";
import { LoadingScreen } from "../components/MiscFunctions"

// reactstrap components
import {
  Container,
  Row,
  Col,
} from "reactstrap";


//styling of the theme
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  }
}));

//function that controls the accordion

function Faq() {
  const classes = useStyles();

  const [frequent, setFrequent] = useState([]);
  useEffect(() => db.Faq.listenAll(setFrequent), [])

  const [expanded, setExpanded] = useState('');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  //returning the title and page this helps in displaying on the actual page
  return (
    //react helmet used in order to optimize the SEO
    <>
      <Helmet>
        <title>FAQ - Smart Event and Production Qatar's Best Event Manager </title>
        <meta name="description" content="View the Frequently Asked Questions of Smart Event and Production - Qatar's 
        best Event manager, best Event organizer, and best Event production. We offer services ranging from
        Wedding events, Birthday events, Sports events, Public Events, Conferences, and many more!"/>
        <meta name="og:title" content="Smart Event and Production - Qatar's Best Event Manager. View our Portfolio here!" />
        <meta name="og:description" content="Smart Event and Production offers services ranging from
        Wedding events, Birthday events, Sports events, Public Events, Conferences, and many more!" />
      </Helmet>
      {/* Navbar  */}
      <WhiteNavbar />
      {
        !frequent || (frequent && frequent.length > 0) ?
          <div className="section section-feature cd-section" id="features" style={{ minHeight: '90vh' }}>
            <div className={classNames(classes.main, classes.mainRaised)} >
              {/* Container containing the title and description */}
              <Container>
                <Row>
                  <Col className="ml-auto mr-auto text-center" md="8">
                    <h1 style={{ color: "#000000", marginTop: "30px", marginBottom: "25px", minHeight: "32px" }}><strong>Frequently Asked Questions (FAQ)</strong></h1>
                    <h5 className="description" style={{color:"#000000"}}>
                      <strong>Here are some of the top most asked questions by our website visitors. Feel Free to scroll around and check out the Questions and Answers. </strong>
                    </h5>
                  </Col>
                </Row>
                {/* Mapping through the db to extarct the questions */}
                {
                  frequent && frequent.map(fre => {
                    return <Question
                      fre={fre}
                      key={fre.id}
                      expanded={expanded}
                      handleChange={handleChange}
                    />
                  })
                }
              </Container>
            </div>
            {/* End of container */}
          </div>
          :
          //If the data is not generated Loading screen animation is called
          <LoadingScreen />
      }
    </>
  );
}

export default Faq;

